import React from 'react';
import { CustomersTableContainer } from '@finance-hub/domain/customers/containers/customers-table-container';
import { usePageLayoutHeaderInset, View } from '@usepepper/sprout-kit-ui';

export const CustomersContent: React.FC = () => {
  const headerInset = usePageLayoutHeaderInset();

  return (
    <View flex={1} marginTop={headerInset} paddingTop="$24" width="100%">
      <CustomersTableContainer />
    </View>
  );
};
